import { Tooltip } from 'antd';
import type { UploadRow } from '@/models/upload';
import {
  uploadBadgeVariant,
  uploadStatusLabel,
  uploadStatusTooltip,
} from '@/features/uploads/utils/uploadStatus';
import styles from './UploadStatusBadge.module.css';

interface UploadStatusBadgeProps {
  upload: UploadRow;
}

export default function UploadStatusBadge({ upload }: UploadStatusBadgeProps) {
  const badge = (
    <span className={styles.badge} data-variant={uploadBadgeVariant(upload)}>
      {uploadStatusLabel(upload)}
    </span>
  );

  const tooltip = uploadStatusTooltip(upload);
  return tooltip ? <Tooltip title={tooltip}>{badge}</Tooltip> : badge;
}
